
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Clear`,
'deleteKey': `⌦ Vymazať`,
'downKey': `↓ Dole`,
'endKey': `⤓ Koniec`,
'enterKey': `Vstúpte na stránku`,
'escapeKey': `⎋ Útek`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Generovať 
          <code>LICENCIA 
          </code> súbor 
        `,
'homeKey': `⤒ Domov`,
'keyCommand': `⌘ Príkaz/Win`,
'keyControl': `^ Kontrola`,
'keyOption': `⌥ Možnosť/Alt`,
'keyShift': `⇧ Posun`,
'leftKey': `← Vľavo`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `▲ Pageup`,
'rightKey': `→ Vpravo`,
's00065e45db8c0441': `Viac informácií nájdete v časti Nástroje pre vývojárov`,
's001dd78415a91fa0': `Žľab posuvníka`,
's002fa7d1054ed082': `Hraničný rámček`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazachstan`,
's01b56d233c6c5cac': `Rozdelenie na sekcie`,
's01d32b35baa3b676': `Autor`,
's02106cc2ef0e7578': `Nový kolík...`,
's02ab1ea8e5100fc1': `Označiť výber ako "obojsmerné prepísanie`,
's0312976fe9da5951': `Tlačidlo`,
's03608a32f05eded2': `Priblíženie pomocou štipky`,
's036d35e03be98d22': `Hĺbka matematiky`,
's037b1dc850a89273': `Alternatívne pod`,
's0396202b716732ec': `Označte výber ako preškrtnutý`,
's03f49e598ffb11cc': `Poľský`,
's0448f1059fa01720': `Uložte, zdieľajte alebo vytlačte svoju prieskumnú úlohu. Upravte informácie, ako je názov, jazyk alebo licencia.`,
's0458872c43beadef': `Vloženie riadku pred`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Medzery medzi slovami`,
's05e9759cfd99c48f': `Odôvodnite`,
's063fa5a0a4903bf4': `Do strany, zľava doprava`,
's064339c229374050': `Kódovanie`,
's06634274f19b0572': `Výber kolíkov`,
's06743b24499f0035': `Kotviace centrum`,
's07808b0ca6da8fef': `Oplotená webová stránka`,
's07970793b21351fd': `Základný kontajner Ruby`,
's079cf7850d9327f0': `Písmo`,
's07aa10850d9ddcc7': `Formulár`,
's07e6118e838b2e23': `Navigácia`,
's0816468df86e4036': `Otvorí nastavenia`,
's082869038c117fe5': `Portugalčina (Brazília)`,
's086e6c267ade2609': `Nasýtenie`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Vloženie zoznamu (bez poradia)`,
's09c3f1d21de14ae1': `Označte výber ako podčiarknutý`,
's0a2d91c6720033e9': `Orezanie medzier medzi textom`,
's0a3ddcba94027d95': `Umiestnenie objektu`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Vloženie navigácie`,
's0a7db790db1fc45c': `Označiť výber ako rozpätie`,
's0b1271f50a77dc73': `Kolónka obsahu`,
's0b24d08ea349b455': `Všetko, čo môžete vložiť. Na začiatku sú neinteraktívne prvky, ako sú zoznamy alebo obrázky, ďalej interaktívne prvky nazývané widgety. Nové môžete získať kliknutím na vyhľadávací panel.`,
's0b7ae9543c001867': `Odpoveď`,
's0bdca49248ba4820': `Skratky`,
's0befccf152b6c0a9': `Orientovať sa z metadát`,
's0c11e479416c8421': `Vloženie nadpisu tabuľky`,
's0c27336067c59611': `Polstrovanie rolovania`,
's0c4593d81f147042': `Základné údaje`,
's0c4b2e98d4ab7f5a': `Príkazy aplikácie`,
's0c883713b83616a8': `Uloženie aktívneho dokumentu`,
's0ca5c0460199cba1': `Skratka`,
's0cf10c4f40588f8d': `Nadpis tabuľky`,
's0d86afa3c6a1e28b': `Smer flex`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Váš dokument na preskúmanie. Môžete tu písať text a kopírovať/vkladať, upravovať atď.`,
's0dc07f97c821463c': `Výber komentárov`,
's0dc452999c129e15': `Povolenie živého načítania`,
's0de0febab8a4beaf': `Chyba pri čítaní tohto balíka`,
's0e44968489e076a8': `Čínsky`,
's0e4862e87c7d53ce': `Označiť výber ako citáciu`,
's0e6ea8870dbddab2': `Príkazy dokumentu`,
's0ee28503778e4c0c': `Posledná základná hodnota`,
's0ef01c03299bbb83': `Dekorácie`,
's0f17f32919661cff': `Mongolský`,
's0f350bc4e538e3ea': `Slová`,
's105540b7756c0232': `Definícia pojmu`,
's105a06836c40fcb4': `Nastavenie filtrov, farieb a prelínania vybraných prvkov`,
's106b274b5af798e5': `Vety`,
's1082e1649793dca9': `Označiť výber ako definovaný pojem`,
's10f3845975a0351e': `Úprava metaúdajov`,
's1125d159f7e64df5': `Zobrazenie`,
's11326fd2590f4e5e': `Predvolené nastavenie`,
's1155ec07a221e739': `Posuvník`,
's1173bf7a3e0b74c9': `Minimum (y)`,
's1177237a3e0e548c': `Minimum (x)`,
's1219d97b49650c05': `Viditeľnosť`,
's123bea44f38abccf': `Vloženie objektu`,
's1245e2cb9f20197e': `Zarovnajte`,
's12946ec1b850962c': `Vloženie stĺpca za`,
's1351209ef74ee729': `Rozpätie všetkých stĺpcov`,
's13c60cb409e8cb6f': `Zarovnanie na stred`,
's13ebd619c8a06a6d': `Automatické riadky mriežky`,
's13ef8ca26ca8861b': `Prvok rezu`,
's151349210ac1d2d8': `Vloženie skupiny`,
's151bc2eea7a032a4': `-zmenené-`,
's153bc3c3aa39587b': `Hlava stola`,
's156647179b21d351': `Vloženie tela tabuľky`,
's158b6ec6b1fffcb2': `Prestávka po`,
's15d0c0657c1ee08c': `Kľúč API`,
's1626a7e10a9f9dcc': `Nastaví rodinu písma výberu`,
's1637c7d1a30629e2': `Hraničný rámček`,
's1641ab440bf4daa4': `Aktualizácia tohto balíka widgetov`,
's166bd56d19670a72': `Priblíženie`,
's1696c76a23c0834e': `Pokročilé: Zobrazenie balíkov s verziami ako 0.x.x v správcovi balíkov`,
's16b9446e3a70e1f4': `Atribúty`,
's16f205466761e583': `Žiadne optické nastavenie veľkosti písma`,
's16f2f1c2c516d307': `Otvorenie dokumentu`,
's1749014f3f87fa6a': `Stretch`,
's17597a8bb4810524': `Licencia`,
's17bfaaa4e7528bc7': `Baškirsko`,
's17fb3f4805f4f4b9': `Odstrániť pole`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Vytvorenie balíka`,
's18d5c44aae3dc82a': `Online pri úpravách`,
's1988d71ef8060edf': `Vloženie riadku tabuľky`,
's19abee1277c9bca2': `Samoan`,
's19daf2f26c19543d': `Náčrt`,
's1a1acc902e6668e0': `Zobrazenie pokročilého formátovania textu`,
's1a5230a71d9285c1': `Zachytenie`,
's1aa1cb63ad44bc6f': `Medzera medzi stĺpcami`,
's1af8b67d1c85c811': `Priestor medzi`,
's1b4a36fce2456660': `Rodina písiem`,
's1c246045629b0016': `Označiť výber ako vymazanie`,
's1c3fc313a9184670': `Verejné prepojenie`,
's1c65f5004a07dcfa': `škótska gaelčina`,
's1c690963f1e2df00': `Vzhľad špecifický pre platformu`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Chcete absolvovať krátku prehliadku so sprievodcom?`,
's1d19244f549ec535': `Vzdelávanie`,
's1d5c7b28e8b50d6d': `doc.`,
's1db591f5a54dbfd3': `Box s obsahom`,
's1dbb9f50e16c92a3': `Polomer hranice`,
's1dfb744260fb3a01': `Obojsmerná izolácia`,
's1e9c2c654732cc5f': `Bieloruský`,
's1eaccbf2d6af8ab5': `Informácie`,
's1efbfc3937d565bd': `Pozadie`,
's1f2b49c1bca2035d': `Katalánčina`,
's1f74bdf32b51a5fc': `Obrázok na pozadí`,
's1f7698c061c208c9': `Otvorte stránku`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Korzičania`,
's21d61916eb8d137d': `Telo tabuľky`,
's21d723a1dbcd89c8': `Javánčina`,
's21f8a2eaf5a70749': `Vloženie štítku`,
's2206c42e5b835e6e': `Označiť výber ako skratku`,
's22a2348c46a912a0': `Vloženie oddielu`,
's233ae776268cd44b': `Obchod`,
's236ed7ba747099b0': `Hmotnosť písma`,
's2474e7fb1aec9f05': `Test`,
's2492f5fb1b05b45e': `Text`,
's24949d7adbb5a098': `Toolbox`,
's252a52330d32b900': `Metadáta`,
's2540844a4bc4d9ba': `Vyžadovať uvedenie autora?`,
's255857544a9d5ec0': `Obnovenie`,
's255c77900f2b5e0f': `Farebná schéma`,
's256ab831a48c941c': `Odstráni z výberu všetko formátovanie textu`,
's2591806d7b222591': `Obnovenie zmien`,
's25e1a07e454c2c11': `Sieť`,
's262abbaf1d05f009': `Mäkké svetlo`,
's266935f2447fcd98': `Nad ľavou stranou`,
's268ecd1cef45a9a8': `Ste si istý?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Odľahčiť`,
's27076e66c5d483ba': `Zvislé zarovnanie`,
's2712dc5641a33226': `Účty registrov balíkov sú určené pre vývojárov a umožňujú konfigurovať jeden alebo
          viac registrov.`,
's2739460e44320108': `Čínština (tradičná)`,
's27cc88818cc46ff6': `Stabilné`,
's281d957112b10f12': `Priama úprava HTML dokumentu`,
's28b6246ce616a548': `Vloženie skupiny stĺpcov tabuľky`,
's29a1c26521879b9f': `Zníženie rozsahu`,
's29acfd2778e8c377': `Skrytie pokročilého formátovania textu`,
's29b24c06315e9343': `Vloženie vstupu`,
's29eb103449472e3b': `Vloženie nadpisu (úroveň 3)`,
's29ee7434494a0dfe': `Vloženie nadpisu (úroveň 2)`,
's29f21c34494d614d': `Vloženie nadpisu (úroveň 1)`,
's29fbfc3449557f72': `Vloženie nadpisu (úroveň 6)`,
's29ff743449588131': `Vloženie nadpisu (úroveň 5)`,
's2a031834495bcdb4': `Vloženie nadpisu (úroveň 4)`,
's2a75c946ef4dcab7': `Rôzne`,
's2b2ae20d26f78ac2': `Blok`,
's2b8f50c64be440f7': str`Vyberte 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Objednávka`,
's2bad2d24def4aa0b': `Zlom riadku (CJK lang.)`,
's2ceb11be2290bb1b': `Zrušiť`,
's2ced8e8fafb499f6': `Odstrániť prvok`,
's2d986d31f8d67357': `Vloženie sady polí`,
's2d995a37cf5e4995': `Vložiť NoScript`,
's2de969afacdaa7a6': `Tvar`,
's2df075aface0dab8': `Zdieľať`,
's2e192b19ed15fcf6': `Strana`,
's2e39b99cf23606fa': `Nastavenie rozloženia vybraných prvkov`,
's2e4818861000b13f': `Rozloženie`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Prečerpanie (y)`,
's2edd6688a65e21f0': `Prečerpanie (x)`,
's2f0bcdffc92a786b': `Plávať vpravo`,
's2f2044f2431a32d5': `Nadpis`,
's2f4d4bfbc466d91f': `Albánčina`,
's2f8da2cb5f236588': `Názov vášho balíka. Musí mať rozsah, napr. \`@org/pkg\`. `,
's30cce87854901922': `Predškolské zariadenia`,
's3124653c272f054c': `Farba pravidla stĺpca`,
's314a4f7685c8e824': `Vždy`,
's31c06e226322f065': `Vyhnite sa sirotám`,
's323dcde72b850272': `Prístup verejnosti`,
's32911e52ee8ac745': `Vložte štrbinu`,
's337a1e9022a8d19f': `Tabuľka`,
's33c1450d2822bb0f': `Vloženie nadpisu obrázka`,
's33c18d5a4cbffa2a': `Írsky`,
's33f85f24c0f5f008': `Uložiť`,
's342b0cabfa672822': `Pomôžte používateľovi nájsť váš widget`,
's3437e0d9899e7ae1': `Odosielanie telemetrických údajov o používaní aplikácie WebWriter.`,
's344ea8f4939cdc98': `Farba`,
's34dcda3b0f9d5a98': `Prepínanie url`,
's34f724979a124c50': `Nastaví farbu pozadia vybraného textu`,
's355b21b89ce5d9c5': `Podrobnosti na`,
's35ae5f4e0fa2777b': `Vlastné zarovnanie`,
's35aeaff1425bca9e': `WebWriter nepodporuje médiá typu `,
's35c3125c7750681e': `Blokový citát`,
's3643189d1abbb7f4': `Kód`,
's3649bacefe731bf6': `Prepínač Toolbox`,
's365280e16a8ea32d': `Kopírovanie výberu`,
's366991b9c9287765': `Vpravo`,
's36a194e38d653a26': `Anotácia údajov`,
's36b3cefdcb897f15': `Perspektíva`,
's372fae706048ce41': `Párne`,
's377e24af9628c37e': `Objednaný zoznam`,
's37a8c35f6581da5f': `Žiadna kotva`,
's37fa3b9cd51c2dfd': `Nastaví veľkosť písma výberu`,
's380d17664bb69531': `Vloženie stĺpca pred`,
's3815184eb09f0dcf': `Kurzor`,
's382a2aa3984474dd': `Vytvoriť stránku`,
's38980f98cb07ceb8': `Uloženie aktívneho dokumentu ako kópie`,
's3914cb410fca44d4': `Import`,
's3a179f6db2972384': `Pozícia Ruby`,
's3a5ca02f282d247e': `Zdieľať...`,
's3ae67088bbefba98': `Balíky`,
's3b0ab4b52326316f': `Svetlo`,
's3bc203a3f8a6409c': `Aktualizácia jazyka v celom dokumente`,
's3bdad99768e11911': `Preskúmateľné`,
's3cb47df8290fa94c': `Vloženie možnosti`,
's3cf89cb47fdde7e9': `Odkaz`,
's3d09398e555ee5f9': `Rozšírené možnosti`,
's3d249bb480032121': `Zoznam`,
's3d3efd1e19bdcfb4': `Anotácia dátumu/času`,
's3d6a732c792ccb9e': `Anotácia Ruby`,
's3d93f9ea0c5a13fa': `Obrázok`,
's3d9548e211b958ce': `Vynechanie prekrývania`,
's3e092e9d1ee2c5bb': `Klip`,
's3e78ddc9a48a608d': `Pekné`,
's3eb6d1e6e79ed7c4': `Nenašli sa žiadne dokumenty`,
's3eca5a034978754b': `Odstránenie výberu`,
's3f06e9abb6ebcb79': `Postavy`,
's3f1e7a3f2b283d3b': `Margin`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gudžarátčina`,
's3f7e097a9b2e6181': `Vložiť článok`,
's3fd83566dd643d10': `Vloženie legendy`,
's3fe72792941c18f9': `Spodná časť textu`,
's3ffcdc5db5e7d0c5': `Reverzný`,
's40e3826b7f74a3b5': `Pan (vpravo)`,
's40f07d7859284a44': `Dominantná základná línia`,
's4101ada154a1b958': `Stred`,
's410c465a5993f82d': `Príležitosť na prerušenie riadkov`,
's41322d19c928c603': `IKT`,
's417b90913e05bc17': `Náhľad`,
's418f2020fe996832': `Potvrdenie zmien`,
's41c724f0698148e9': `Označenie výberu ako klávesovej skratky`,
's41f65a763f8e44ab': `Skupina záhlaví tabuliek`,
's42721130228841b0': `Políčko pre ťahy`,
's429bd646f1cf8bc6': `Účty Grammar LLM umožňujú používať rozhranie API Grammar LLM na opravu gramatiky v texte.`,
's429dd933ba95549b': `Vloženie adresy`,
's42e470ef1d707a28': `Automatické prehrávanie`,
's42ffdab1291fb3de': `Vloženie riadku za`,
's430831017f3f0499': `Skew (y)`,
's430bd5017f42511c': `Skew (x)`,
's433ba70286202ceb': `Rozbiť všetky`,
's441b20a8a50e36b4': `Macedónčina`,
's445b8acb9206db6e': `Vyradiť a zrušiť`,
's446a924922651ea0': `Zvýraznenie textu`,
's44cdba92713de38e': `Oblasť mriežky`,
's45518abd911471d0': `Chorvátsky`,
's456a8d744313852a': `Priestor okolo`,
's4634541f5056a546': `Abcházsko`,
's46d4abe6255cb9e1': `Opätovné priradenie skratky`,
's4730c232e7209c40': `Orezávanie oboch`,
's474f0eec369d02a4': `Ukážka výstupu`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Označenie výberu ako anotácie dátumu/času`,
's47ebf3a8fb3b10c1': `Orientácia`,
's4802bb8eb52fbdeb': `Portál`,
's4802e47fe2e95134': `Možnosť`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Textový tieň`,
's4993444bfd3f3e5e': `Zrútenie`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Maska`,
's49dd67aed00029ef': `Matematika`,
's49e763aed00877a8': `Hlavná stránka`,
's4a894f57eba1cf1e': `Klávesová skratka`,
's4ac1ad6ecd6bd810': `Rôzne vyd.`,
's4ad6e9d3c2365c98': `Tvrdé svetlo`,
's4b2c143acf931122': `Výška riadku`,
's4b58c01e2578f5e4': `Legenda`,
's4bbff4e008690da1': `Vyhnúť sa stránke`,
's4c402ff5355fd310': `Obojsmerné prepínanie`,
's4caed5b7a7e5d89b': `Angličtina`,
's4cb38675a21b2c98': `Nepodporovaný typ vlastnosti '\${desc.type}' (spracovanie ako JSON)`,
's4cc8391f172c0cdf': `Rozpustiť prehliadku`,
's4ce8cc041a628847': `Po zmene jazyka dokumentu sa zodpovedajúcim spôsobom aktualizujú jazyky všetkých widgetov.`,
's4d528b416ac8dee2': `Vloženie skupiny nadpisov`,
's4d546f6c87128d5b': `Priestor ako prvý`,
's4dcb9315f6527f9c': `Spustiť pri opätovnom načítaní`,
's4e191bdb4700a6e9': `Posunutie na druhú stranu (x)`,
's4e1c7fdb470386ac': `Posunutie na druhú stranu (y)`,
's4e2562fe3990e621': `Chyba pripojenia`,
's4e361bf8eef3759a': `Prestávka na slovo`,
's4ea0f21fc2a338a1': `Posunúť sa nahor`,
's4eace13b3ed74187': `Vedľajší komentár`,
's4efee5b48a4593cb': `Slučka`,
's4f26e7cb7c0a8318': `Vektorové kreslenie`,
's4fd2e638aabb0bb3': `WebWriter podporuje vkladanie mnohých rôznych zdrojov. Jednoducho vložte odkaz na
          obsah z:`,
's4fda04cbc245e18b': `Alfa`,
's4ffac3fb33a2ee9b': `Thai`,
's5015a8fb33b98872': `Tenké`,
's50489ffb1bde152e': `Vloženie`,
's5068560b8d39663d': `Klikateľná mapa`,
's517acbf1f96324f9': `Hmotnosť`,
's523eb9043213ff0d': `Kurzíva`,
's52777d434baeed9b': `Vloženie indikátora pokroku`,
's52af5d7ac34c2163': `Riadok tabuľky`,
's52e0bdc3ee304436': `Vloženie merača`,
's52fb1524cb25d7ab': `Nové vlákno`,
's531056f039febd39': `Vloženie výberu`,
's536695196d0b6dc3': `Faeroese`,
's542fcefa0bbaed86': `Otvorenie alebo zatvorenie súpravy nástrojov (len na úzkych obrazovkách, inak je súprava nástrojov vždy viditeľná na boku).`,
's5432ad3c84273229': `Obrázok`,
's543906d1db8b2283': `Upraviť `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Kambodža`,
's54897f2764b0e4d0': `Inštalácia tohto balíka widgetov`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Označte výber ako veľmi dôležitý`,
's55905c735052d295': `Tematická prestávka`,
's5590dbf7e425789d': `Štítok`,
's5623aa2f83b05c76': `Tibeťan`,
's564d1648b1ceee9f': `Aktuálne`,
's565cd5ffb0158c46': `Vyhnite sa regiónu`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Vráťte sa späť`,
's5787c6d5b3b5541a': `Cesta klipu`,
's579c69f419b6caef': `Hladký`,
's587ac858dd80f6fa': `Index`,
's58bec0ecd4f3ccd4': `Prísne`,
's59404f5593c32fdc': `Kerning písma`,
's5941292bb77281ab': `Nórsky jazyk Bokmål`,
's599dcd2472c75c19': `Odsek`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Označenie výberu anotáciou údajov`,
's5a356677b61a6b7e': `Moldavsko`,
's5b474b5c0ac0c7c4': `Skupina stĺpcov tabuľky`,
's5b517ac216f9ee62': `Bokom`,
's5b8cc9bb61ddce15': `Vloženie odseku`,
's5bba2ac2e53bd1fd': `Kirgiz`,
's5be80ad6b8301710': `Inline štart`,
's5c1ecf88259b79f9': `Prezentácia`,
's5c2a1a52c0389c30': `Inžinierstvo`,
's5c63af7695445fcf': `Štýl textu`,
's5d18ca4c3111be6f': `Vloženie hlavičky tabuľky`,
's5d87c1e588f48d90': `Cvičenie`,
's5d929ff1619ac0c9': `Vyhľadávanie`,
's5da52af9b083c29a': `Model`,
's5dc77784260a7236': `auto`,
's5e27738a2e8eb763': `Prihlásiť sa`,
's5e2cba97c0d971bd': `Načítanie balíkov`,
's5e53415a6d5719ad': `Spoločenské vedy`,
's5e6a7a0c30d2a270': `Vynechať prekrývanie (automaticky)`,
's5e9e8e4d21bafedc': `Výroba potravín`,
's5ed03bb1f3a15949': `Obrázok`,
's5f43af3669b1e098': `Zdroj`,
's5feaf7fd7ee567c8': `Slovo prestávka`,
's600fd23c9ce971e8': `Tlač aktívneho dokumentu`,
's602bbd28dae2c60f': `Samostatný štart`,
's60ff598dfcf2c773': `V rámci práva`,
's61053f0e3ebbd272': `normálne`,
's613c6ff83883c04f': `Stĺpec tabuľky`,
's6196153c4b0c1ea0': `Inštalácia stránky`,
's61c017f6d5c303af': `Frízština`,
's61ded17ca3f48c82': `Posunutie podčiarknutia`,
's61eacb19db252f5e': `ADRESA URL`,
's621ad19d35ba7742': `Výber kópie`,
's624e31cd4f1b89d4': `Hladké posúvanie`,
's626daf42b1ab7df7': `Zarovnať doľava`,
's6280bf993915c57a': `Okraj posúvania`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Popis`,
's63dfc5b1c1c27849': `Jidiš`,
's63e03c70f67ebf9c': `Kontext`,
's63e71d20d1eaca93': `Nemčina`,
's640bc7710d0143ce': `Znovu vykonať poslednú zrušenú zmenu v aktívnom dokumente`,
's64dc1fc7e3db45c9': `Vytvorenie nového dokumentu`,
's65ac276544ba33cd': `Súbor SVG`,
's66765c420ee578e4': `Priestor rovnomerne`,
's669b18c6d2d9c95b': `Žiadne`,
's6747dbf4ad6063ba': `Vlastný koniec`,
's6787497df07fa97e': `Môže prechádzať cez zastávky`,
's67c2b60a506a09e4': `Stredoškolské vydanie.`,
's680bd4d926cd5a84': `Zachovať 3D`,
's6827930ef1aeaf99': `Základná adresa URL`,
's684a16f3c711394d': `Nad pravou stranou`,
's687e27f036a71b32': `Izolujte`,
's68b87d7b61052dc3': `Riadok tabuľky`,
's68e0e3a2bab7ce3e': `Vyhnite sa stránke`,
's690da6b432987c6f': `Automatické zálohovanie zmien v aktuálnom dokumente. Zmeny sa obnovia pri opätovnom načítaní programu WebWriter.`,
's69311c4e25074fb3': `Stredná škola`,
's697400b541fbc3cd': `Pod`,
's6988ab5d47593a26': `Máte najnovšiu verziu programu WebWriter.`,
's69a49786a8009f43': `Nájsť balíky...`,
's69b12144dbb6544d': `Laothian`,
's69d88ef4b2618980': `Obal`,
's69fbbdb8ad2a084a': `Stmaviť`,
's6a31eff1ec4f71ad': `Skryť zadnú tvár (3D)`,
's6ac62e1c8c66f3bb': `Kompaktné superskriptá.`,
's6b585ba37cdb8260': `Zdediť`,
's6b61f8abf89586be': `Hebrejčina`,
's6bd7a02fdf93e653': `Zosúladenie obsahu`,
's6cfc66b824ea05ba': `Ostré okraje`,
's6d02dc19e21eb49c': `Top`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnamci`,
's6d8b3b8047ed378d': `Režim prelínania Mix`,
's6d8c02aee480af7a': `Ponuka`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Vloženie štýlu`,
's6e288a119281f4c2': `Vykresľovanie textu`,
's6e4c20c6debcd5ca': `Vlastné odôvodnenie`,
's6f84199e62584905': `Predformátovaný text`,
's6fb3053e7244d326': `Ostatné oblasti`,
's70178e04a3b691b6': `Otvoriť nastavenia`,
's7031ca562378bde6': `Geometrická presnosť`,
's7060970b5ed20a58': `Interaktivita`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Zobraziť nestabilné balíky`,
's71dec51005acc1e4': `Hustý riadok`,
's72f2a02e2a5a4ee3': `Médiá`,
's730182ad28374cda': `Objekt`,
's731678e227a20559': `Toto zariadenie`,
's736904f276fbd441': `Prírodné vedy`,
's739544d0c858c633': str`Alebo upustite od 
          ${0} tu 
        `,
's73cb20c838e761e1': `Výber rezu`,
's7417792bbe720149': `Redo`,
's741fae02b3dd24f3': `Pixelated`,
's743f778233e42a3f': `Vložte poznámku`,
's744d993d03f29851': `Obrazovka`,
's74540c1b595a229c': `Vzorec TeX`,
's748c0074eff45884': `Manipulácia`,
's74aa0039a87141e2': `Elipsa`,
's74b9781bacfcc87c': `Punjabi`,
's74cd20a7aece9b91': `Vyplňte políčko`,
's75109f5307578a61': `Vitajte v službe WebWriter`,
's75a27f43413e02c5': `Francúzsky`,
's75d83fc3f0cfab40': `Záhlavie`,
's762e5704cc84089d': `Nastavenie ďalších možností štýlu vybraných prvkov`,
's77318393dfdb0775': `Odstrániť riadok`,
's77e594ddcc10c774': `Povolenie komerčného využitia?`,
's780099588362f80f': `Položka definície`,
's782eac2b3e80323d': `Označte výber ako zdôraznený`,
's782f286a79cca35d': `Relatívny`,
's78673a3539cb1915': `Vľavo hore`,
's78789724e789221c': `Veľkosť`,
's789ff24c8f03f1a4': `Medzery medzi písmenami`,
's7995733bf97c01cc': `Srbsko-chorvátsky`,
's7a99528e7b64635a': `Occitan`,
's7aaf0c06e69600f1': `Chyba s `,
's7ae49e142487766c': `Prístup Spoločenstva`,
's7af555180b30a947': `Otvorte nástroje pre vývojárov`,
's7b4ba250601b8667': `Vloženie šablóny`,
's7b560d8693ed8f42': `Vzpriamené`,
's7b9994904c4f5b54': `Tadžik`,
's7bdf0fd5b014d36c': `Veľký význam`,
's7beb1e77e82363eb': `Zrušenie poslednej zmeny v aktívnom dokumente`,
's7c61118554a0ec36': `Maximum (x)`,
's7c95876637f6a9d7': `Filter`,
's7cb4e55c59663b1c': `Spoločnosť`,
's7cfe12cd14df9950': `Odhlásiť sa`,
's7d27db3c9639c6dd': `Alternatívny`,
's7d8103f6f06f83d6': `Vypchávky`,
's7d864465dddbb50d': `Povolenie zmeny veľkosti`,
's7de0e28d6c309a4e': `Povolenie dotykových akcií`,
's7dea785045c3cc74': `Stlačte novú kombináciu klávesov...`,
's7e0b179d4d1414eb': `Zadajte odkaz`,
's7e6570f2f1ae320f': `Syntetizovať písma`,
's7ecb1f29332293e5': `Základná línia vyrovnania`,
's7ed13ccddb1bf3c3': `Prekrytie`,
's7edbe0b213199995': `Bakalársky titul`,
's7ede1c55e35ce9d6': `Simulácia`,
's7f09197a4814079b': `Nastavenie možností interaktivity pre vybrané prvky`,
's7f326a142e856656': `Štýl`,
's7fcb35d23be1e643': `Súbor polí`,
's80570196a9ce6d11': `Povolenie telemetrie`,
's806f84eb0ace116e': `Pozrite si, čo ste vybrali, a zmeňte to. Kopírujte, vystrihujte, vkladajte, pripínajte alebo upravujte rozloženie. Ponúka rôzne možnosti v závislosti od vášho výberu, t. j. formátovanie textu.`,
's80a42b81c52d4d8f': `Farba hlásky`,
's80b71fc6f43c5ce1': `Voľné stránky`,
's812cbda653daaeba': `Táto funkcia ešte nie je implementovaná`,
's81c3d8809658b951': `Kašmír`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Pokračovať`,
's8247d32213e35f24': `Vloženie hlavného`,
's82665b2ffabc9c0a': `Webová lokalita`,
's828b1ecea8715884': `Pan (vľavo)`,
's833bd0422a7ef95d': `Veľkosť karty`,
's83420ad7b6a14db5': `Prepínanie nástrojov Dev Tools`,
's83c15613b6f6f3c8': `Len online`,
's83cd32b685ccc9b7': `Ovládacie prvky`,
's83f26d02dd7aa681': `Viditeľné`,
's840fa49e8989c028': `Poloha/tvar`,
's844a76d1843ceb3c': `Obnovenie predvoleného nastavenia`,
's84e4e8ae645b82ac': `Vpravo hore (y)`,
's84e9c7f8785ca60b': `Vloženie formulára`,
's8517ae4da104b004': `Skupina stĺpcov tabuľky`,
's85186a61e0d55bac': `Video`,
's851a7deea5984646': `Licencia Creative Commons OER?`,
's85f9aa6d3ea0e421': `Skupina päty tabuľky`,
's864b0e6270e97246': `Označte výber ako vedľajšiu poznámku`,
's8670e5ad3bf0dcf8': `Uložiť ako`,
's8688d74dd3716d6e': `Klávesové skratky pre príkazy`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Tvarové rozpätie`,
's87cefc710b3567fb': `Obsahuje`,
's88676f992b2965db': `Roztiahnutie obsahu bunky`,
's886897f2fd4edb99': `Skryté`,
's886c5db2a5579873': `Koncept`,
's888c71e8fcb916d3': `Automatické ukladanie`,
's88a62d29529948fb': `Vloženie tabuľky`,
's89950d86c8004d4b': `Nevynechať žiadne prekrývanie`,
's89bca7498f20e041': `Klip na pozadí`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Prestávka pred`,
's8a4ff2bd9c13498c': `Záznam`,
's8a6585c48ea104e9': `Skryť prázdne bunky`,
's8a9eb438abac7c6a': `Štítky`,
's8b0432eecbd8b034': `Aktualizácia`,
's8b7580c35e2aef87': `Vľavo hore (y)`,
's8bc4affa761aa8a2': `Vloženie obrázka`,
's8c7f51cb067644c7': `Zoznam údajov`,
's8d342ecaa9e75b9b': `Vzťah`,
's8d797888455f4147': `Priestory na prestávky`,
's8d83386457e91813': `Vráťte späť/opravte svoje zmeny alebo si ich prezrite z pohľadu žiaka.`,
's8d8643013a7754d1': `Zarovnanie textu`,
's8df30fe2a50d3479': `Vloženie možnosti prerušenia riadku`,
's8e715248c3a78446': `Rozstrihnúť výber`,
's8f29e48d6b9a1aa8': `Vloženie riadku záhlavia tabuľky`,
's8f4be9f086eb530f': `Zrušiť`,
's8f533296a536965e': `Uložiť ako...`,
's8fad58c831ecf017': `Textový kontajner Ruby`,
's8ffe7abcbed8eb43': `Vertikálne, zľava doprava`,
's90105521fcc40453': `Kontá WebWriter Cloud umožňujú ukladať dokumenty online a zdieľať ich so študentmi.
          Pridajte si tu konto a bude k dispozícii ako miesto na ukladanie, načítanie, zdieľanie a
          otváranie dokumentov.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Paleta písiem`,
's90f7c1cf501ea0a7': `Farebný úskok`,
's91093e0b087911ba': `Pozícia s dôrazom`,
's919e1724f589c9b1': `Slot`,
's91c5ed7769d00b65': `Vložiť vloženie`,
's9219acd5bef6269e': `Pod ľavou rukou`,
's92548405912d46bf': `Zarovnanie pri posúvaní (y)`,
's9258280591309342': `Zarovnanie pri posúvaní (x)`,
's927d796559f49439': `Pozadie Pôvod`,
's92b177e579ef7b97': `Zdôraznenie`,
's92f846b9be2e8e8d': `Označiť výber ako kurzívu`,
's93566b84230af4f5': `Vloženie obrázka`,
's936aa0b239679585': `Vloženie tematického zlomu (zvyčajne sa zobrazuje ako vodorovná čiara)`,
's9370dc6afa716b57': `Hranica`,
's93f083e654a45715': `Breton`,
's94653c76b2d86a04': `Definovaný termín`,
's9485af2e7cd9418f': `Základná škola`,
's94d2eee44b292567': `Prepínanie rozšírených možností`,
's94d61907ee22a8c1': `Kórejský`,
's94eb1effbbb6498b': `Pretekanie`,
's951aa3a6439f1271': `Značka zoznamu`,
's9565553d163fc92a': `Skript`,
's957787fc6b7ea5c0': `Pan (nahor)`,
's95d56e58f816d211': `Holandský`,
's95d8e41a64635c7c': `Biely priestor`,
's95de7e1eff6c053e': `Horizontálne, zhora nadol`,
's960d3a90ac199368': `Rétorománsky`,
's96532132a29dd542': `Vloženie zvuku`,
's96a045dcade75ad0': `Hustý stĺpec`,
's9781a5bb3fcb26a3': `Vyberte si najprv spoločnosť`,
's978522fbc9577a7e': `Somálsko`,
's97881699a2b21d5b': `Medzera v riadku`,
's97aa76056a81bd36': `Metriky`,
's986facb3ecc9602c': `Do strany, sprava doľava`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Externý súbor`,
's98977a87d1b93941': `Obnovenie informácií, štýlov a skriptov`,
's98b1cb8fb62909ec': `Skupina`,
's990d0e0fa2ab00b5': `Galícia`,
's99229574e5692f19': `Grónsko`,
's99a990f3841ad283': `Súbory `,
's99b38e000175cc84': `Prečiarknutie`,
's99f110d27e30b289': `Názov`,
's9ab10fbf4c7a7322': `Pozícia podčiarknutia`,
's9abadcc828884d7b': `Textový priestor`,
's9b7cd8860c8fc922': str`
          ${0}
          sa prepíšu. Ste si istí? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Farba pozadia`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Stĺpec tabuľky`,
's9cf68f87b8e6122f': `Azerbajdžan`,
's9d167ef77aed79b6': `Vrstva`,
's9d2d00982edafabb': `Turecký`,
's9d430adc5be110e9': `Obrátený rad`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Odstránenie`,
's9df571714a1efb44': `K dispozícii je automaticky uložená verzia tohto prieskumníka. Načítate ju?`,
's9e28faa598332e2b': `Vloženie videa`,
's9e3dbb678150edd4': `Nastavenie rodiny písma`,
's9e40e59654c8ad67': `Stĺpec`,
's9e85800d3700e31c': `Trať`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Variant písma`,
's9f1ecdb3061d9cbc': `Zachovať priestory`,
's9faf26107ed49fb9': `Vloženie bunky tabuľky`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Prechod`,
's9ff3121d30f88d52': `Normálne`,
's9ffe1bbe64712bf1': `Plátno`,
'sa00df4e39c72d3b4': str`
          ${0} nie je podporovaná 
        `,
'sa013e119fec906fb': `Riadok`,
'sa01e7bf33563ef72': `Základná príloha`,
'sa126cf8c627cec1e': `Vykresľovanie obrázkov`,
'sa13f72278add7513': `Vpravo`,
'sa1647e3b36ec08d7': `Kombinujte vzpriamene`,
'sa172190ea21f9b1c': `Prejdite do nastavení, otvorte prieskumnú položku alebo vytvorte novú.`,
'sa1c6c459b9b5115c': `Absolútne`,
'sa2cba871f6cdd99f': `Assamese`,
'sa2eff4dad1c119f1': `Šablóna mriežky`,
'sa30c12014e955946': `Ruský`,
'sa30f1981fd1cd441': `Veľkosť písma`,
'sa311a24c1471a974': `Dokument`,
'sa352d168b262aa06': `Vloženie päty`,
'sa37fee6a52d18063': `Odstrániť dokument`,
'sa39c7ac1d37f3bce': `Označiť výber ako "obojsmerný izolát`,
'sa3b4c01623211544': `Sila`,
'sa40fd43756fa8913': `Perzský`,
'sa417644bef21a9aa': `Nepomenovaná téma`,
'sa43800e28be1bdbc': `Farba dekorácie`,
'sa477cb1825dceb3b': `Sudánci`,
'sa492a51a707930fa': `Vloženie blokového citátu`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Titulok v dolnej časti`,
'sa50d3c35533f1d99': `Všetky polia`,
'sa53c5cb03a8fda50': `Pripnutie výberu ako úryvku v palete`,
'sa557ae6bee9148a6': `Pokrok`,
'sa589e1df65dde0ec': `Nastavenie veľkosti, výplne a okrajov vybraných prvkov`,
'sa5c371b4bb75e590': `Vľavo`,
'sa5c80e623459ffe4': `Vloženie záhlavia`,
'sa5df1bcdba46c3fb': `Obrázok Titulok`,
'sa602e3fd3f2d98fd': `Animácia`,
'sa644d580d8a11e60': `Zarovnanie rubínu`,
'sa645d315510dc09e': `Výber cesty z disku`,
'sa65d4ad99f1d8c06': `Nastavenie pozadia textu`,
'sa6607436f60ccc1a': `Estónčina`,
'sa6f8d27bca557059': `Presun prvkov meta/odkaz/štýl nahor/dole do tohto prvku`,
'sa757645ad842da97': `Zachovať prestávky`,
'sa75b95980cd80e78': `Editor`,
'sa7698b3d20a6d1ec': `Rolovanie`,
'sa778acc33947c7b8': `Dokončenie prehliadky`,
'sa78a67272a4a6f95': `Matematický vzorec`,
'sa79167651dce1e80': `Alternatívny text`,
'sa7af797a46c7d09a': `Päta tabuľky`,
'sa7dbe35b758c138d': `Vloženie plátna`,
'sa7dc6b8ef3f595dc': `Vloženie zdroja`,
'sa8279f8211b3950d': `Zachovať prestávky a priestory`,
'sa8b55cab62e439b5': `Odstránenie stĺpca`,
'sa8bbe0197d31b423': `Krátky popis`,
'sa9ff3b762365abe6': `Pôvod transformácie (z)`,
'saa02e3762368ff35': `Pôvod transformácie (y)`,
'saa065776236bfa28': `Pôvod transformácie (x)`,
'saa33768e03c45fc8': `Veľkosť súboru`,
'saaad98061a20ac39': `Vloženie matematického vzorca`,
'saab875d8cfcfe712': `Téma`,
'saad4380b9cc6cefd': `Striedanie cez`,
'saaec15c97a9e4245': `Obrátenie stĺpca`,
'sab0c57df694a0a09': `Začiatok úpravy`,
'sab4d9283896d9422': `Pixely rozlíšenia Snap`,
'sab55faae8e165407': `Výplň&lt;br&gt; ako medzera`,
'sab5e7d2a069a2951': `Odborné osvedčenie.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Zarovnať doprava`,
'sac895c732f350ac5': `Dark`,
'saced41ddda8b2354': `Flexibilný základ`,
'sad190f86451081c0': `Nepálsky`,
'sad6be321164d08c8': `Kompaktná matematika`,
'sadd352cc7f6f2307': `Okrem`,
'sae098810f946ca7c': `Tagalog`,
'sae185e6af80ec81e': `Švédsky`,
'sae1c7f13b7c0c47f': `Štart`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tatar`,
'saf312eaeec77a802': `Vloženie zoznamu popisu (slovník pojmov, zoznam pojmov)`,
'saf3da7c95cb17260': `Označiť výber ako horný index`,
'saf440a0a592f2835': `Aktualizácia na`,
'saf9e5134ba1a7d30': `Scroll snap`,
'safc6f203342d09e2': `Prepína náhľad aktívneho dokumentu`,
'sb0a7e3adf4a125ee': `Vpravo hore`,
'sb0a974028c99ca6d': `Povolenie úprav?`,
'sb0d4f0f7993cf085': `Nastavenie veľkosti písma`,
'sb0f3327210fe18fc': `Stĺpce`,
'sb0f93c1c60c0249a': `Rubínová základňa`,
'sb1494c08c8c720d1': `Nastavenie farby textu`,
'sb19611adbc88f711': `Pokročilé: Zobraziť príkazy na úpravu zdroja, napr. na zobrazenie HTML dokumentu alebo na pridanie vlastných štýlov a skriptov.`,
'sb206d700d26b14ff': `Podčiarknite`,
'sb233557012dcb328': `Posunúť sa nadol`,
'sb26035b596566abf': `Bez názvu`,
'sb2cda80610c8d6ea': `Priestor pre všetkých`,
'sb2dc787b0983ebc6': `Litovský`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Stredisko`,
'sb3ba3276ae93627c': `Vloženie predformátovaného textového bloku`,
'sb430f5b4824de0d3': `Výber rozloženia`,
'sb43db07b24da018a': `Amharčina`,
'sb45f9fb4dba6e71a': `Nenastavené`,
'sb4e003a459464d85': `Kurdská`,
'sb4f0310e6787d098': `Uzbek`,
'sb4f1dffbb6be6302': `Jasné`,
'sb51270e19988f9bd': `Región`,
'sb59d621e3c93cc27': `Spoločné hranice buniek`,
'sb5e9e1776242b028': `Interakcie`,
'sb60bc1250aad44c1': `Rozpätie`,
'sb60dd9d23d31ee66': `Doktorát`,
'sb6103872073d369e': `Vložte podrobnosti`,
'sb616811735bfbafd': `Tabuľková bunka`,
'sb628960829e223bb': `Vynechať všetky prekrývania`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Aplikovať a importovať`,
'sb66e2181a7b5738a': `Povolením telemetrie povoľujete zhromažďovanie a uchovávanie údajov podľa našich`,
'sb67e0e7c0869f982': `Rozdiel`,
'sb68e83cda6c85af8': `Záhlavie tabuľky`,
'sb6b268120592dc53': `Hindčina`,
'sb6ca0a8bb3caae69': `Hrúbka dekorácie`,
'sb70c17f7899f9b01': `Latinčina`,
'sb71941f552f3504d': `Nastavenie špeciálnej hodnoty`,
'sb740eab4afd5a710': `Automatický tok siete`,
'sb741b6e0ca589122': `Vrátenie vrstvy`,
'sb7c77d0415de05cf': `Spustenie testov`,
'sb7fb7568f6883ab8': `Zdieľanie aktívneho dokumentu`,
'sb85774dc5d18ff0f': `Potvrďte`,
'sb85b1e36579852a6': `Neplatný e-mail alebo heslo`,
'sb884fa76bfc55429': `Arabčina`,
'sb8a3d4df7d1c5e6b': `Bilancia`,
'sb8f610a0e8df91fc': `Svietivosť`,
'sb8f855b49234b81b': `Aplikovať`,
'sb905da066c10182c': `Navyše tmavšie`,
'sb940ade1bd81be7e': `Pod ľavou rukou`,
'sb9e9a7dd45966756': `Označte výber ako tučný`,
'sba509fd8ed61d1d5': `Neuložený súbor`,
'sba64d8954d027206': `Nepriehľadnosť`,
'sba88d90cd6c751b3': `Pravidlo stĺpca`,
'sbaf0a7c417e388af': `Zdravie`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Filter pozadia`,
'sbb85a407d730e13d': `Vloženie vyhľadávania`,
'sbb86c6c96f598bb8': `Zmiešané`,
'sbba0156f795d8c07': `Upraviť výber`,
'sbba865d4b437944f': `Atribút`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Odinštalovanie stránky`,
'sbc5f2a81604baf9b': `Položka 6`,
'sbc5f2b81604bb14e': `Položka 5`,
'sbc5f2c81604bb301': `Položka 4`,
'sbc5f2d81604bb4b4': `Položka 3`,
'sbc5f2e81604bb667': `Položka 2`,
'sbc6953a36ced943f': `zásady ochrany osobných údajov`,
'sbd181cd54b8402a4': `Úprava výberu`,
'sbd35ee879d9cf770': `Rubínový text`,
'sbd40f40cbadd38d5': `Odstránenie tohto balíka widgetov`,
'sbd72dc858de95ce8': `Barmský`,
'sbe3c60c65f129daa': `Humanitné vedy`,
'sbe4a7c8f231739b3': `alebo vložte/vysuňte/vyberte súbor`,
'sbe90de083557ef3e': `Svahilčina`,
'sbefb6064cba01844': `Vloženie zalomenia riadku`,
'sbf00e1ee999ea94e': `Vloženie skriptu`,
'sbf519920c2017d67': `Závesné`,
'sbfa01f189a68d3e9': `Flex rast`,
'sbff54e740c4086eb': `Zobraziť neznáme balíky`,
'sbfff51feacf30196': `Sanskrit`,
'sc0ceaa9843510f67': `Turkméni`,
'sc1611c0558728a2a': `Pozícia`,
'sc1a155cc25899250': `Skupina riadkov tabuľky`,
'sc1aa1f6051b7102a': `Rumunský`,
'sc1edebeaef92b7bd': `Pevné rozloženie tabuľky`,
'sc1fff4f356dfb2fb': `Transformácia`,
'sc221faca1ecb4aee': `Anonymný`,
'sc24bda3c061fddf8': `Klikateľná oblasť`,
'sc252a4e091763606': `Vloženie päty tabuľky`,
'sc2536e077514accc': `Rolovanie`,
'sc275dd00036d16cb': `Citáty charakter`,
'sc28864200d2a3799': `Skopírujte kód QR ako obrázok`,
'sc2a24a9dd41a9503': `Linka dekorácie`,
'sc2b734cca2fa643b': `Pan (nadol)`,
'sc2e2a0dbf03723b7': `Pokročilé: Zobrazenie balíkov z neznámych zdrojov v správcovi balíkov (Varovanie: Môže byť nebezpečné)`,
'sc3998b77d72c2932': `Vloženie webovej stránky (ako riadkový rám)`,
'sc3ac225273c8316b': `Všeobecné`,
'sc3cfee84dbbf36ae': `Miestny súbor`,
'sc3f09a9b6fa4fbed': `Vnútri`,
'sc43767deea72e9f3': `Zoznam popisov`,
'sc462bbdd36bcba6b': `Referenčný rámček`,
'sc4ee3e4ee994dafd': `Ukrajinský`,
'sc50d09edf9325339': `Dialóg`,
'sc52b67794c06a0d3': `Perspektívny pôvod (y)`,
'sc52e8b794c0913d6': `Perspektívny pôvod (x)`,
'sc53de149fcaad713': `Medzi postavami`,
'sc546f489f9c0cced': `Prepína testovací režim pre aktívny dokument`,
'sc5bcf50d1b578d9f': `Nastavenia funkcie písma`,
'sc5cb39478b9b7625': `Označiť výber ako index`,
'sc6415b50ff928294': `Položka zoznamu`,
'sc650ff15b20fe9d3': `Otáčanie (z)`,
'sc6578b15b2154365': `Otáčanie (x)`,
'sc65aff15b2183e58': `Otáčanie (y)`,
'sc6da0f4a7e4d710e': `Prepísanie jazyka písma`,
'sc74e3567875ce255': `Značka vášho widgetu aj názov vášho balíka NPM`,
'sc7eb080b96e244df': `Malajčina`,
'sc8ac7ef92b95df3f': `Presun (x)`,
'sc8af536e2084ade0': `Paleta`,
'sc8b022f92b992bc2': `Presun (y)`,
'sc8b39af92b9c2d81': `Presun (z)`,
'sc8d2c7f6c33a2b32': `Nastavenie štýlu textu (zarovnanie, odsadenie, medzery atď.) vybraných prvkov`,
'sc8fa0e3de389ef1c': `Nastavenie veľkosti písma`,
'sc9474bf7a0668d73': `Zhrnutie`,
'sc94e314312a8900c': `Český`,
'sc980855a000b76ea': `Spodná časť`,
'sc98b103772de63f4': `Fínsky`,
'sca7cfe2bef51b2a5': `Koreň`,
'sca7fed2bef53cb99': `Úloha`,
'scabe6ecee5e01fd2': `Maltský`,
'scace301a88231cce': `Vložiť`,
'scbc55f622ec078c1': `Zobraziť box`,
'scbe537fc38ff4c13': `Automatické stĺpce mriežky`,
'scc1db59d292cbc4c': `Sekcia`,
'scc56b218a2689c42': `Arménsky`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Políčko Výplň`,
'scd9cedeb5ece3adb': `Prepojenie`,
'scdf536b65be39ec5': ` Vytvorenie/import`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideografické`,
'sceecdd0bb404bc17': `Vloženie skupiny možností`,
'scf00d48fd5953a03': `Grécky`,
'scf932840a69dbb7c': `Portugalčina`,
'scf932a8577057752': `Zápätie`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Vpravo dole`,
'sd01178c54f648118': `Stĺpce bilancie`,
'sd03bff50f87f82d4': `Prepojený znak`,
'sd05a155fe09c2866': `Online pri používaní`,
'sd0864ea6cb6ef22e': `Komunita`,
'sd10fdbe6caf9a998': `Prerušenie riadkov`,
'sd121d3b959b7888d': `Optimalizácia rýchlosti`,
'sd1a78e667a1a139f': `Označiť výber ako vloženie`,
'sd1cffad290ea5b3b': `Ponechajte si všetky`,
'sd1f10284eeb17b25': `Fidži`,
'sd1f44f1a8bc20e67': `E-mail`,
'sd1f81984eeb7c0e8': `Naplňte stránku`,
'sd29dc07235eea0f5': `Citácia`,
'sd2addf69477cd4b4': `Import balíka`,
'sd2ed26defc646d47': `Filter pozadia`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Opravené`,
'sd3a288c1094b8a63': `Šírka pravidla stĺpca`,
'sd3c65ef5c380c046': `Vložka`,
'sd3dcb76f7b28adb8': `Lotyšský`,
'sd3eca1e0f4209f6e': `Orežte všetky`,
'sd3f402df8619ddcd': `Tieto informácie o vás sa automaticky pridávajú do nových dokumentov. Môžete to
          zmeniť pre každý dokument v editore metadát.`,
'sd4368b12645d3c0f': `Vloženie portálu`,
'sd452cebf4a0313d1': `Zobraziť príkazy na úpravu zdroja`,
'sd48cc52117f4d68b': `Taliansky`,
'sd52660ee947ca58b': `Vloženie stĺpca tabuľky`,
'sd588d17a1b25c220': `Pretekanie textu`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Vyššie vzdelávanie.`,
'sd5cf95145e4d89ca': `Odstráňte tento úryvok`,
'sd5fd9d11a92f5b1d': `Vľavo dole (y)`,
'sd60c9bbc51375635': `Vloženie tlačidla`,
'sd66c4767fa3dde28': `Farba akcentu`,
'sd679c8b1bf8cc8a5': `Malé kapitalizácie`,
'sd7086c4425c53c80': `Rodina písiem`,
'sd837f42ac7cbfb58': `Tvar (vonkajší)`,
'sd88076d2994ee0fb': `Vylúčenie`,
'sd89a2e529b31ef43': `Vrátiť`,
'sd8a345e95668b73b': `Vertikálne, sprava doľava`,
'sd8ce9e57270b030d': `Roztiahnutie písma`,
'sd8ecf227c7c49331': `Matematické`,
'sd8f923198e0c5c6a': `Koniec`,
'sd9c21e5f60d6bdd8': `Dánsky`,
'sd9ff8e2612e63d50': `Veľkosť rámčeka`,
'sda2d76b976502a8d': `Otvorené...`,
'sda344aacb837387e': `Poloha v kontajneri`,
'sda5b6fa8b771f996': `Plávať vľavo`,
'sda9254d1f1228e1a': `Maďarský`,
'sdb1595f5c742dfbb': `Vstup`,
'sdb711380a28fec75': `Vloženie zoznamu (usporiadaného)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `Vpravo dole (y)`,
'sdc12d4d35420eeb7': `Komentáre`,
'sdc48456f9a27ae02': `Generátor`,
'sdc70d81cf6c28533': `Gruzínsky`,
'sdd1ff479d04ac140': `Verejnosť`,
'sdd2fc8919a9c3111': `Režim prelínania pozadia`,
'sdd35b688281b6dea': `Japonský`,
'sddc49047f66a64ab': `Neposkytol sa žiadny opis`,
'sdef34fe08bb28b09': `Čínština (zjednodušená)`,
'sdf62e305e1594805': `Označenie výberu rubínovou poznámkou`,
'sdf946172dfa0328f': `Superscript`,
'sdf9bc5d9b7f3e3de': `Zarovnanie`,
'se036b53f145441cd': `Zmiešaný obsah`,
'se06f459fccdc3ce9': `Zarovnanie posledného riadku textu`,
'se0a782a8be8e018b': `Nórsky`,
'se0cda6b80a1bb50f': `Slovenská`,
'se0f67eae944f8f94': `Vypnutie zvuku`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Článok`,
'se1f5bb0386c88f96': `Nastaví farbu vybraného textu`,
'se219da7b1e955c65': `Jasné formátovanie`,
'se25e4f2cb77b8be8': `Jazyk pre rozhranie WebWriter a nové dokumenty`,
'se2796c5824ec8916': `Viditeľnosť obsahu`,
'se308836a594808b6': `Singhalese`,
'se36c5b1baf5e0660': `Kdekoľvek`,
'se39c065efa467782': `Baskicko`,
'se3b4c857f91f80d7': `Klávesové skratky`,
'se47baf2fd16b9d2b': `Šablóna`,
'se48bd9e6c2a3109d': `Účty`,
'se58467472725ad0c': `Rozlíšenie obrazu`,
'se58f06c2b0583ff7': `Vyberte súradnice`,
'se5dc1e97fb743ade': `Rozstupy`,
'se619a501d1bfe6a5': `Zabaľte`,
'se62385ac082368d2': `Označenie výberu ako zdroja citácie`,
'se6297163cac9d276': `Upraviť zdroj`,
'se633223a0b88625e': `Umiestnenie buniek`,
'se638417c560cfe5c': `Prelomenie vo vnútri`,
'se64f418b4e733b6c': `Vloženie výstupu`,
'se79c0a3ac70d8fb3': `Asp. pomer (x)`,
'se79fae3ac710dc36': `Asp. pomer (y)`,
'se7fad370d8fb4cec': `Optimalizácia čitateľnosti`,
'se8a94b4effa2033e': `Abecedné`,
'se95d4e55ea186d9a': `Farba posuvníka`,
'se96d43a515b8451c': `Slovinčina`,
'se96fd76ba1b2975a': `Centrálna stránka`,
'se9ac05f36b004eb0': `Skryte úvodnú prehliadku. Zakážte, aby sa prehliadka opäť zobrazila.`,
'se9b1fec72ffd8f48': `Miestne stránky`,
'sea24bdcaa2bd2dec': `Povinné snímanie`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Prepína editor metadát`,
'sea896ed51ad33287': `Nie sú k dispozícii žiadne špecifické štýly`,
'seaaaeb09e3b4e78b': `Príkazy na úpravu`,
'seabae79729c4b2ad': `Prepínanie e-mailu`,
'seaecc8267bad6234': `Stredná škola`,
'seaf97719986faf4f': `Medzera`,
'seb19675a580f0628': `Vyhnite sa stĺpcu`,
'seb4e52ef5ec7a7dc': `Farby/efekty`,
'seb8982ae8c3cdcc5': `Indonézsky`,
'sebbced89e0db2894': `Prvá základná úroveň`,
'sec02109a0dd2a6c8': `Zvýraznená farba`,
'sec2557a35b702525': `Variabilné`,
'sec2da4aa7a02b925': `Islandský`,
'sec30fbb20f102670': `Vložte zhrnutie`,
'sec8b0b6c729816b6': `Skupina záhlaví`,
'seccd05955adb76bc': `Plagát`,
'sed17285cd25d6389': `Adresár, v ktorom sa nachádza súbor package.json`,
'sed318ec045c5144f': `Viac ako`,
'sed713f1b916fb469': `Vzdialenosť medzi hranicami (x)`,
'sed74a31b9172942c': `Vzdialenosť medzi hranicami (y)`,
'sed86bd0deb2e5372': `Transformácia textu`,
'see2fcaedf9743ec6': `Umiestnenie`,
'seec6798afe90ffc8': `Tlač`,
'sef00c258bc1ecf1e': `Tento prieskumník má nezachované zmeny.`,
'sef23dd271edd4a8b': `Vľavo dole`,
'sef24caccbd4645ef': `Zmenšovanie flexibility`,
'sef49aec68fd1dc66': `Názov`,
'sef73fe18e351eb35': `Kľúčové slová`,
'sef75f458d77491af': `Skupina možností`,
'sefcf950b3cc4fc3b': `Jazyk`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Obsah`,
'sf0cab2483f66aa2e': `Vlastné`,
'sf0e261e04eda82ff': `Vzhľad`,
'sf1045382c1fd9a85': `Presné farby tlače`,
'sf14c35392ec7bf10': `Táto funkcia nie je v prehliadači Firefox k dispozícii. Je dostupná v prehliadači Chrome alebo Edge.`,
'sf14f9d5f9f6ca342': `Plus ľahšie`,
'sf1868dc19e3917bb': `Španielčina`,
'sf190149f9d8bbb2a': `Režim písania`,
'sf1e79171c4856543': `Ste si istý? Túto akciu nemožno vrátiť späť, všetky vaše nastavenia sa vymažú a
          obnovia.`,
'sf21c1f60c7515f44': `Označiť výber ako výstup vzorky`,
'sf21fb4f4b9e8911f': `Šírka`,
'sf22a3737146ec910': `WebWriter môže vkladať SVG priamo do dokumentu.`,
'sf2514d5dc78b1654': `Vloženie widgetu`,
'sf28903d4ca0ddcfc': `Odstrániť toto konto`,
'sf2ab37af0abc55ef': `Skryť úvodnú prehliadku`,
'sf2bdb0b4d7b9c039': `Bengálčina`,
'sf2cbb5e519264e67': `Zmena veľkosti vo vodorovnom aj zvislom smere`,
'sf2d5cbc2fe0ad65a': `Sticky`,
'sf2d96d0eb32cb81f': `Zloženie animácie`,
'sf2de3dbe2108637a': `Vykresľovanie tvaru`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Vloženie skladby`,
'sf3c4da68b08a2590': `Malgašsko`,
'sf471ec2496f904cc': `Vyradenie zmien`,
'sf4849bc200e279ed': `Nadpis tabuľky`,
'sf486ca1fdbe08645': `Vložiť obrázok`,
'sf4b537d4cbd8f5fd': `Text hore`,
'sf4e0e02a5277ef23': `Vloženie textového poľa`,
'sf4f067d41efd4b83': `Mierka (y)`,
'sf4f3cbd41f002b46': `Mierka (x)`,
'sf4fa67d41f05a008': `Mierka (z)`,
'sf5197db2d5f2926a': `Otočiť`,
'sf52d840949a980d1': str`
          ${0}
          budú natrvalo vymazané. Ste si istí? 
        `,
'sf55d634dcc743595': `Služby`,
'sf59c9081d106dd9c': `Označiť výber ako premennú`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Odstránenie dokumentu`,
'sf65df67a03bebe4b': `Požadované pre tento widget`,
'sf6673729c03ae999': `Obnovenie programu WebWriter`,
'sf67571992e7dc88e': `Celý termín`,
'sf6b4934598f7ed10': `Povoliť výber`,
'sf6e1665c7022a1f8': `Heslo`,
'sf79e0d78b56444f1': `Inline koniec`,
'sf7a5f7a7c80c3082': `Obe stránky`,
'sf7c0eba7c822e3d6': `Odvážne`,
'sf86bd4d2982f3b74': `Označiť výber ako kód`,
'sf8e82313fa411494': `Označiť výber ako prepojenie`,
'sf955eff73fb6b573': `Srbský`,
'sf9929e2d356260c5': `Násobiť`,
'sf993bb199fefbe04': `Všetky`,
'sf9ecf969dd4b8164': `Oba okraje`,
'sf9f2c719a04066ec': `Aplikácia`,
'sfa49a5bb1a5d353e': `Súkromný prístup`,
'sfa59c7777e2a0eeb': `Vloženie zoznamu údajov`,
'sfaa0a67db5c11f72': `Odsadenie prvého riadku textu`,
'sfb231a52211b133f': `Žiadne obtekanie textu`,
'sfb68cae41d749423': `Úvodná stránka`,
'sfb9b6edb0ed378c9': `Zdroj citácie`,
'sfbbab09dbe553571': `Vloženie vektorovej kresby (SVG)`,
'sfc00292e778b67e2': `Merač`,
'sfc63e31ac7c956ed': `Vyberte`,
'sfc815c9078bba30a': `Stiahnutie kódu QR ako obrázka`,
'sfcdd8e672c75b713': `Adresa`,
'sfcebd18506f1e535': `Prietok`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Výstup`,
'sfdb1e4d90981a535': `Zdieľanie tohto dokumentu`,
'sfdeef3dccf409f81': `Toto kľúčové slovo je potrebné pre widgety`,
'sfe6e758ad2603c1d': `Magisterský titul`,
'sfee1c12daf838935': `Vypaľovanie farieb`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Vloženie dialógového okna`,
'sffa395f64ec6ac36': `Bulharský`,
'sffdadf0a576fd802': `Výška`,
'spaceKey': `Priestor`,
'tabKey': `⭾ Karta`,
'upKey': `↑ Nahor`,
    };
  